import { Tab } from 'semantic-ui-react';
import Tables from './Tables';
import Chart from './Chart';

const panes = [
    {
        menuItem: 'Chart',
        render: () => (
            <Tab.Pane>
                <Chart />
            </Tab.Pane>
        ),
    },
    {
        menuItem: 'Data',
        render: () => (
            <Tab.Pane>
                <Tables />
            </Tab.Pane>
        ),
    },
];

const Tabs = () => <Tab panes={panes} />;

export default Tabs;
